import { render, staticRenderFns } from "./commandes.html?vue&type=template&id=7c666595&scoped=true&external"
import script from "./commandes.js?vue&type=script&lang=js&external"
export * from "./commandes.js?vue&type=script&lang=js&external"
import style0 from "./commandes.scss?vue&type=style&index=0&id=7c666595&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c666595",
  null
  
)

export default component.exports